






































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import QuestionOfPaperType from "@/store/entities/questionOfPaperTypes";

class PageImportQuestionRequest extends PageRequest {
  keyword: string;
  classTypeId: number = 3;
  multiTypeName: string = "章节";
  GradeType: number = 0;
  parentId?: number;
  parentName: string = "上级分类";
  questionType: number = 0;
  degreeDifficulty: number = 1;
  testPaperId: string = "";
  sectionId?: number = 0;
  QuestionAuditFlow: number = 1;
  rangeSectionChapters: string = "";
}

@Component({})
export default class ImportQuestion extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  //filters
  pagerequest: PageImportQuestionRequest = new PageImportQuestionRequest();
  questionOfPaperType: QuestionOfPaperType = new QuestionOfPaperType();
  editModalShow: boolean = false;
  backshow: boolean = true;
  screenWidth: number = document.body.clientWidth - 200;
  multiTypes: any = [];
  data: any = [];
  showme: string = "测试";
  valueArray: any = [];
  newtabdata: any = [
    { value: 0, label: "判断题" },
    { value: 1, label: "单选题" },
    { value: 2, label: "多选题" },
    { value: 3, label: "填空题" },
    { value: 4, label: "计算题" },
    { value: 8, label: "解答题" },
    { value: 9, label: "作文题" },
    { value: 10, label: "探究题" },
    { value: 11, label: "材料题" },
    { value: 12, label: "实践题" },
    { value: 7, label: "选考单选" },
    { value: 5, label: "选考多选" },
    { value: 6, label: "选考计算" },
  ];

  //checkgroup
  socials: any = [];
  checkSelct: boolean = false;

  async auditedTestQuestion() {
    await this.$store.dispatch({
      type: "testQuestion/auditedTestQuestion",
      data: {
        id: this.questionOfPaperType.id,
        questionType: this.questionOfPaperType.questionType,
        operationEnum: 1,
      }, //组卷次数加1
    });
  }

  /**
   * 回到顶部功能实现过程：
   * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
   * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
   * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
   * 4. 最后记得在移动到顶部时，清除定时器
   */

  btnImportQtuestion() {
    if (
      this.questionOfPaperType.questionDetail.imported &&
      this.questionOfPaperType.questionDetail.imported.length > 0
    ) {
      this.$store
        .dispatch({
          type: "testPaper/importQuestionadd",
          data: this.questionOfPaperType,
        })
        .then((res) => {
          if (res.success) {
            this.auditedTestQuestion();
            this.getpaper();
          }
        });
      //组卷次数加1
    } else {
      this.$Message.warning("没有选择试题");
    }
  }
  handleCheck(id, value) {
    if (value) {
      this.questionOfPaperType.questionDetail.imported.push(id);
    } else {
      this.questionOfPaperType.questionDetail.imported.forEach(
        (item, index, arr) => {
          if (item === id) {
            arr.splice(index, 1);
          }
        }
      );
    }
  }
  getpaper() {
    this.$store
      .dispatch({
        type: "testPaper/getadd",
        data: { id: this.pagerequest.testPaperId },
      })
      .then((res) => {
        this.$store.state.editTestPaper = res;
        this.$emit("save-success");
        this.$emit("input", false);
      })
      .catch((err) => {});
  }
  udata() {
    let udata = this.$store.state.testPaper.cascaders.items;
    let valueArrayb = this.$store.state.testPaper.editTestPaper.categoryList;
    let temp = [];
    if (valueArrayb.length > 0) {
      this.pagerequest.sectionId = Number(valueArrayb[valueArrayb.length - 1]);
      udata.forEach((item, index, arr) => {
        if (item.id === valueArrayb[0]) {
          temp = arr[index];
        }
      });
    }
    this.data = [];
    this.data.push(temp);
    if (this.data.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("save-success");
      this.$emit("input", value);
    } else {
      if (this.udata()) {
        setTimeout(() => {
          this.valueArray =
            this.$store.state.testPaper.editTestPaper.categoryList;
        }, 1000);
      }
      this.questionOfPaperType =
        this.$store.state.testPaper.questionOfPaperType;
      this.pagerequest.questionType = this.questionOfPaperType.questionType;
      this.pagerequest.degreeDifficulty =
        this.questionOfPaperType.questionDetail.degreeDifficulty;
      this.pagerequest.testPaperId = this.questionOfPaperType.id;
      this.pagerequest.rangeSectionChapters =
        this.$store.state.testPaper.editTestPaper.rangeSectionChapters;
      this.initData();
      this.getpage();
    }
  }
  edit() {
    this.editModalShow = true;
  }
  sisterQuestion(id) {}
  async stateSwitching(id) {
    await this.$store.dispatch({
      type: "testQuestion/showStateSwitching",
      data: { id: id, questionType: this.pagerequest.questionType },
    });
    this.getpage();
  }
  async updateQuestion(row) {
    this.$store.commit("testQuestion/edit", row);
    this.edit();
  }
  async deleteQuestion(id) {
    await this.$store.dispatch({
      type: "testQuestion/delete",
      data: { id: id, questionType: this.pagerequest.questionType },
    });
    this.getpage();
  }
  UsdegreeDifficulty(value) {
    if (value == 1) {
      return "(A层次)";
    } else if (value == 2) {
      return "(B层次)";
    } else {
      return "(C层次)";
    }
  }
  questionTypeChange(value) {
    this.pagerequest.questionType = value;
    this.initData();
    this.getpage();
  }
  cascaderSelect(value, selectedData) {
    if (value.length > 0) {
      this.pagerequest.sectionId = selectedData[selectedData.length - 1].value;
    } else {
      this.pagerequest.sectionId = null;
    }
    // this.pagerequest.rangeSectionChapters = "";
    this.getpage();
  }
  handleRefresh() {
    this.loadCascaders();
    this.getpage();
  }
  get list() {
    return this.$store.state.testQuestion.list;
  }
  get loading() {
    return this.$store.state.testQuestion.loading;
  }
  initData() {
    this.$store.state.testQuestion.totalCount = 0;
    this.$store.state.testQuestion.currentPage = 1;
    this.$store.state.testQuestion.list = null;
  }
  pageChange(page: number) {
    this.$store.commit("testQuestion/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("testQuestion/setPageSize", pagesize);
    this.getpage();
  }
  async loadCascaders() {
    await this.$store.dispatch({
      type: "testQuestion/getCascader",
      data: { classTypeId: this.pagerequest.classTypeId },
    });
    this.data = this.$store.state.testQuestion.cascaders.items;
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "testQuestion/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.testQuestion.pageSize;
  }
  get totalCount() {
    return this.$store.state.testQuestion.totalCount;
  }
  get currentPage() {
    return this.$store.state.testQuestion.currentPage;
  }
  getTypeName(classTypeId) {
    for (var item of this.multiTypes) {
      if (item.id === classTypeId) return item.text;
    }
  }
}
